/**
 * The shell every structured card inside a message shares — visit cards, quote cards,
 * availability, time frames, link previews, visit reports.
 *
 * A class string rather than a component because the cards are not all the same element:
 * some are a `<div>`, some a `<Link>`, some a `divide-y` stack with their own footer row.
 * What they genuinely share is only the shell — one light surface, one border, one radius
 * and one width — and that was the piece copied, with drift, across six files.
 *
 * Width: full, at every breakpoint. The cards used to cap at `w-90` (360px, Figma) from
 * `sm` up, which stranded them beside empty space in the wide surfaces (the member thread
 * is a 512px column, the office aside ~400px) and made a message holding two cards of
 * different kinds read as two different widths. A percentage width does not survive a
 * shrink-to-fit parent, so a bubble holding one of these cards has to claim the column
 * itself — `conversation-message-item`'s `hasFullWidthContent` is where that happens.
 *
 * Radius: 8px, which is the radius concentric with the bubble these cards sit in —
 * `Bubble` is `rounded-2xl` (16px) with `p-2` (8px), and 16 − 8 = 8. The shell was
 * `rounded-xl` (12px), 4px over-round against its own container. The border moved down
 * with it, to the `-min` step, so the card reads as a panel inside the bubble rather than
 * as a second frame around it.
 */

import { cn } from "cn";

export const messageCardClassName = cn(
  /* sorted */
  "w-full max-w-full",
  "bg-bg-light",
  "border border-border-dark-min rounded-lg",
);
